export enum NotificationTypes {
  unknown = 0,
  reportDownloadReady = 1
}
